module.exports = __webpack_public_path__ + "img/about_ico4.64c9fe3e.png";